import { mapkeysConstants, alertConstants } from '../_constants'
const initialState = {
  isLoading: false,
  mapkeysList: [],
  isGetAllError: false,
  updateMapkeysMessage: null,
}

export function mapkeys(state = { ...initialState }, action) {
  state = {
    ...state,
    updateMapkeysMessage: null,

  }
  switch (action.type) {
  case alertConstants.CLEAR:
    return {
      ...state,
      updateMapkeysMessage: null,
      isGetAllError: false,
    }
  case mapkeysConstants.GETALL_SUCCESS:
    return {
      ...state,
      mapkeysList: action.mapkeys,

      isLoading: false,
    }
  case mapkeysConstants.GETALL_FAILURE:
    return {
      error: action.error,
      mapkeysList: null,
      isLoading: false,
    }
  case mapkeysConstants.GETALL_REQUEST:
    return {
      error: null,
      mapkeysList:[],
      isLoading: true,
    }
  case mapkeysConstants.UPDATE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      updateMapkeysMessage: action.mapkeys.message,

    }
  case mapkeysConstants.UPDATE_REQUEST:
    return {
      ...state,
      isLoading: true,
      updateMapkeysMessage: null
    }
  default:
    return state
  }
}
